import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { Meta } from 'common/components/meta';
import Attribute from 'marketing/common/attribute';

const ProjectDown = () => {
  return (
    <div className="error-page l-content">
      <Meta
        title="Project Is Down"
        meta={[{ name: "robots", content: "noindex,nofollow" }]}
      />
      <div id="content" className="row">
        <div className="small-16 medium-8 column error-content align-middle">
          <h1>Projects sometimes need a good nap.</h1>
          <p>
            We've temporarily put this project down for a nap. Please <Link to="/help/">contact our
            support team</Link> if you have any questions.
          </p>
        </div>
        <div className="small-16 medium-8 columns">
          <div className="error-image">
            <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_sleeping-sheep-annasmoke.png" alt="Sheep by Annasmoke"/>
            <Attribute to="annasmoke"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDown;



// WEBPACK FOOTER //
// ./error/components/project_down.jsx